import { gql } from '@apollo/client';

export const GET_PAGE_AREA_BROKERS = gql`
  query getPageMapAreaBrokers($input: PageBrokersInput!) {
    getPageMapAreaBrokers(input: $input) {
      count
      list {
        name
        email
        cellphone
        title
        path
        offices {
          list {
            id
            name
            urltag
          }
        }
      }
    }
  }
`;
